import { deleteUserSetting } from './deleteUserSetting';
import { saveUserSetting } from './saveUserSetting';

export const uicontrollerCallMap = {
  saveUserSetting: saveUserSetting,
  deleteUserSetting: deleteUserSetting,
};
